// extracted by mini-css-extract-plugin
export default {"container":"reviews_container__8rglO","title":"reviews_title__nzDC2","tabContainer":"reviews_tabContainer__5bR6U","tabLabel":"reviews_tabLabel__dapMF"};